<!--
 * @Author: Src
 * @Date: 2025-05-14 10:38:27
 * @LastEditTime: 2025-05-14 23:24:06
 * @LastEditors: Src
 * @FilePath: /mobile-station/src/views/privacy/upLoad.vue
 * @Description: 头部注释配置模板
-->
<template>
    <el-upload :action="`${BASE_URL}/tool/auth-phone/upload`" :show-file-list="false" :data="{resourceType: '1',auth_code:auth_code}"
        :on-success="handleAvatarSuccess" :before-upload="beforeAvatarUpload" :on-error="handleError" class="avatar-uploader" :accept="accept">
        <img v-if="imageUrl" :src="imageUrl" class="avatar">
        <div v-else class="avatar-uploader-icon">
            <i :class="uploading ? 'el-icon-loading' : 'el-icon-plus'"></i>
            <div style="font-size: 12px; color: #999;">{{ uploading ? '上传中' : text }}</div>
        </div>
    </el-upload>
</template>
<script lang="ts">
import { Vue, Component, Prop } from 'vue-property-decorator';
import { BASE_URL } from '@/common/constant';

@Component({
    components: {

    }
})
export default class UpLoad extends Vue {
    imageUrl = '';

    accept = 'image/*';
    uploading = false;
    
    @Prop({ type: String, default: '' })
     text?: string;

    BASE_URL = BASE_URL;

    @Prop({ type: String, default: '' })
    auth_code?: string;

    @Prop({ type: String, default: '' })
    type?: string;
    
    handleAvatarSuccess(res: any, file: any) {
        const url = res.data;
        this.imageUrl = url[0].url;
        this.$emit('success', url[0], this.type);
        this.uploading = false;
    }
    handleError(error: any) {
        console.log(error);
        this.uploading = false;
        const errMessage = JSON.parse(error.message);// 获取错误信息
        this.$message.error(errMessage.error);
    }
    beforeAvatarUpload(file: any) {
        this.uploading = true;
        const isLt2M = file.size / 1024 / 1024 < 20;
        if (!isLt2M) {
            this.$message.error('上传头像图片大小不能超过 20MB!');
        }

        return isLt2M;
    }
    emitSuccess(url: string) {
        this.uploading = false;
        this.$emit('success', url);
    }

}
</script>
<style lang="scss" scoped>
.avatar-uploader {
    width: 100px;
    height: 100px;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-direction: column;
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
}
.avatar-uploader-icon{
    line-height: 20px;
}
.avatar{
    width: 80px;
    height: 80px;

}
</style>